import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Neighborhood} from '../models/neighborhood';

@Injectable({
  providedIn: 'root'
})
export class FilterService implements OnDestroy {
  onDestroy$ = new Subject<boolean>();

  neighborhoods$ = new BehaviorSubject<Neighborhood[]>([]);
  reset$ = new BehaviorSubject<boolean>(false);
  toggle$  = new BehaviorSubject<boolean>(false);

  constructor(private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  addFilters(newQueryParams: any) {
    this.router.navigate([], {relativeTo: this.route, queryParams: {...newQueryParams}, queryParamsHandling: 'merge'}).finally();
  }

  resetFilter() {
    if (this.router.url.indexOf('?') >= 0) {
      const url = this.router.url.substring(0, this.router.url.indexOf('?'));
      this.router.navigateByUrl(url).finally();
    }

    this.reset$.next(true)
  }

  toggleFilter() {
    this.toggle$.next(!this.toggle$.value)
  }
}
